import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import {
  HeaderComponent,
  HeaderLeftSlotOutletComponent,
  ToastContainerComponent,
} from '@ps-gui/shared-core';
import { filter, startWith } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'dashboard-root',
  templateUrl: './app.component.html',
  imports: [RouterModule, HeaderComponent, HeaderLeftSlotOutletComponent, ToastContainerComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  protected readonly router = inject(Router);
  protected readonly showHeader = signal(true);

  constructor() {
    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        startWith(null),
        takeUntilDestroyed(),
      )
      .subscribe(() => {
        this.showHeader.set(!this.currentRouteData()['hideHeader']);
      });
  }

  private currentRouteData(): Record<string, unknown> {
    let route = this.router.routerState.snapshot.root;
    const data = { ...route.data };

    while (route.firstChild) {
      route = route.firstChild;
      Object.assign(data, route.data);
    }

    return data;
  }
}
